<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'locationimg',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data"></contenttitle>
      <div ref="locationcontainer" style="margin-top:50px;margin-bottom:50px;position: relative;perspective: 1000px; perspective-origin: center">
        <img :style="{transform:' rotateX('+wheelY*4+'deg)'}" @load="loaded" :src="addip(data.pic)" style="width: 100%;height:auto;transform-origin: bottom;" />
        <div :style="{transform:'translateY('+(-wheelY*10)+'px)   scale('+(1+wheelY/10)+')',left:getLocation(item.x),top:getLocation(item.y),color:data.color}" class="location-box box-shadow "   v-for="(item,i) in data.child" :key="i">

          <a :href="item.url" >
            <a-tooltip :title="item.name" >
              <img class="location-dot" :src="addip(item.pic)"   />
            </a-tooltip>
          </a>
        </div>
      </div>
    </div>
</template>
<script setup lang="ts" name="locationimg">
import {defineComponent,defineProps,onMounted,ref } from 'vue'
import {addip,getCol} from '@/utils/util'
defineProps({
  data:Object
})
const w=ref<Number>(0)
const h=ref<Number>(0)
const getLocation=(num:FLoat)=>{
  let v='10%'
  if(num){
    v= num*100+"%"
  }
  return v
}
const loaded=(event)=>{
  w.value=event.target.offsetWidth
  h.value=event.target.offsetHeight
}
const locationcontainer=ref()
const wheelY=ref<Number>(0)
const handleWheel=(e)=>{
  if(e.deltaY>0){
      wheelY.value++
      if(wheelY.value>10){
        wheelY.value=10
      }else{
        e.preventDefault()
      }
  }else{
      wheelY.value--
      if(wheelY.value<0){
        wheelY.value=0
      }else{
         e.preventDefault()
      }
  }

}
onMounted(()=>{
  locationcontainer.value.addEventListener('wheel', handleWheel);
})
</script>
<style lang="less">
.locationimg{
  img{transition: all .2s linear;}
  .location-box{
        position: absolute;transition: all .2s linear;transform-origin:50% 100%;z-index: 1;
    .location-dot{
        max-width: 256px;  height: auto;
    }
  }
  .location-box:hover{z-index: 100;transform: translateZ(100px);}
}
</style>
